import { SUPER_ADMIN } from "../constants/user";

export const isSuperAdmin = (activeUser) => {
  return (
    activeUser?.groups?.filter((group) => {
      return group?.name === SUPER_ADMIN;
    }).length > 0
  );
};

export const hasPermissions = (permissions, activeUser) => {
  return activeUser?.groups?.some((item) => permissions.includes(item?.name));
};

export const filterDashboardsBySection = (analyticsSection) => {
  return (row) => {
    return analyticsSection === "dashboards" || analyticsSection === "dashboard"
      ? row.type === "dashboard"
      : row.type !== "dashboard";
  };
};

/**
 * Filter dashboards that have sites assigned by the selected site
 * Dashboards that do not have sites assigned are allowed
 */
export const filterDashboardsBySite = (selectedSite) => {
  return (row) => {
    if (!row?.sites || !Array.isArray(row.sites) || row.sites.length < 1) return true;
    return row.sites.filter((site) => site && site.id === selectedSite?.id).length > 0;
  };
};

/**
 * Filter dashboards based on user's group access permissions
 * If dashboard's groupAccess array is empty, everyone has access
 * If groupAccess contains roles, check if user has any of those roles
 * Super Admin always has access regardless of restrictions
 */
export const filterDashboardsByGroupAccess = (activeUser) => {
  return (row) => {
    // If no groupAccess array or it's empty, everyone has access
    if (!row?.groupAccess || row.groupAccess.length === 0) {
      return true;
    }

    // Super Admin always has access to everything
    if (isSuperAdmin(activeUser)) {
      return true;
    }

    // If user has no groups, deny access when groupAccess has restrictions
    if (!activeUser?.groups || activeUser.groups.length === 0) {
      return false;
    }

    // Check if user has any of the required roles (by ID or name)
    const userGroupIds = activeUser.groups.map(group => group?.id).filter(Boolean);
    const userGroupNames = activeUser.groups.map(group => 
      typeof group === "string" ? group : group?.name
    ).filter(Boolean);

    return row.groupAccess.some((requiredAccess) => 
      userGroupIds.includes(requiredAccess) || userGroupNames.includes(requiredAccess)
    );
  };
};

export const sortDashboardsByName = () => {
  return (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0);
};

export const getDashboardsByAccess = (data, analyticsSection, selectedSite, activeUser) => {
  if (!data?.rows) return [];
  // filter reports to what the user has access to
  // type: "dashboard", "report", "paginated",
  // filter reports by site access and group access
  let filteredRows = data.rows;

  if (analyticsSection) {
    filteredRows = filteredRows.filter(filterDashboardsBySection(analyticsSection));
  }

  return filteredRows
    .filter(filterDashboardsBySite(selectedSite))
    .filter(filterDashboardsByGroupAccess(activeUser))
    .sort(sortDashboardsByName());
};
